import React from 'react';
import { useLanguage } from '../context/LanguageContext';

/**
 * Location Section Component
 * Features:
 * - Dark gradient background
 * - Prominent CTA button
 * - Centered content layout
 */
const Location = () => {
  const { t } = useLanguage();

  return (
    <section className="relative py-16 sm:py-20 lg:py-24 px-4 sm:px-6 lg:px-8 text-white overflow-hidden">
      {/* Animated Gradient Background */}
      <div className="absolute inset-0 bg-gradient-to-br from-primary-bronze via-[#7a5230] to-primary-navy animate-gradient" 
           style={{
             backgroundSize: '200% 200%',
             backgroundImage: 'linear-gradient(135deg, #644222 0%, #7a5230 25%, #2a2a4e 50%, #644222 75%, #7a5230 100%)'
           }} />
      
      {/* Overlay for better text readability */}
      <div className="absolute inset-0 bg-black/20" />
      
      <div className="relative z-10 max-w-4xl mx-auto text-center">
        <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold mb-6 sm:mb-8 drop-shadow-lg">
          {t('home.locationTitle')}
        </h2>
        <p className="text-base sm:text-lg lg:text-xl opacity-90 leading-relaxed mb-8 sm:mb-12 drop-shadow-md">
          {t('home.locationText')}
        </p>
        <a
          href="https://royalroomsbbnapoli.kross.travel/"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-block bg-white text-primary-bronze px-8 sm:px-12 py-4 sm:py-5 rounded-lg font-bold text-base sm:text-lg shadow-2xl hover:bg-cream hover:text-primary-bronze hover:-translate-y-2 hover:shadow-3xl transition-all duration-300 transform"
        >
          {t('home.locationCTA')}
        </a>
      </div>
    </section>
  );
};

export default Location;

